<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(onsubmit)">
      <ValidationProvider rules="required|email" name="Email" v-slot="{ errors }">
        <va-input
          v-model="credentials.email"
          type="email"
          :label="$t('auth.email')"
          :error="errors.length > 0"
          :success="errors.length == 0 && credentials.email.length > 0"
          :error-messages="errors"
        />
      </ValidationProvider>
      <ValidationProvider rules="required" name="Senha" v-slot="{ errors }">
        <va-input
          v-model="credentials.password"
          type="password"
          :label="$t('auth.password')"
          :error="errors.length > 0"
          :success="errors.length == 0 && credentials.password.length > 0"
          :messages="errors"
        />
      </ValidationProvider>
      <!-- <div class="auth-layout__options d-flex align--center justify--space-between">
        <va-checkbox v-model="credentials.keepLoggedIn" class="mb-0" :label="$t('auth.keep_logged_in')"/>
        <router-link class="ml-1 link" :to="{name: 'recover-password'}">{{$t('auth.recover_password')}}</router-link>
      </div> -->

      <div class="d-flex justify--center mt-3">
        <va-button type="submit" class="my-0">{{ $t('auth.login') }}</va-button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      credentials: {
        email: '',
        password: '',
        keepLoggedIn: true,
      },
      emailErrors: [],
      passwordErrors: [],
    }
  },
  computed: {
    formReady () {
      return !this.emailErrors.length && !this.passwordErrors.length
    },
  },
  methods: {
    launchToast (text, icon, onComplete = null) {
      this.showToast(
        text,
        {
          icon: icon,
          position: 'top-right',
          duration: 1000,
          fullWidth: false,
          onComplete: onComplete,
        },
      )
    },
    onsubmit () {
      // TODO: Fazer a Validação do Formulario
      this.emailErrors = this.credentials.email ? [] : ['Email is required']
      this.passwordErrors = this.credentials.password ? [] : ['Password is required']
      if (!this.formReady) {
        return
      }
      const self = this
      const { dispatch } = self.$store
      dispatch('authenticate/login', this.credentials)
        .then(response => {
          self.launchToast(
            this.$t('auth.sucess_login'),
            'fa-check',
            () => {
              if (response.data.role === 'external') {
                self.$router.push({ name: 'posts' })
              } else if (response.data.role === 'partner') {
                self.$router.push({ name: 'partners' })
              } else {
                self.$router.push({ name: 'dashboard' })
              }
            },
          )
        })
        .catch(error => {
          if (Object.keys(error).some((value) => value === 'response')) {
            const message = []
            Object.keys(error.response.data).forEach((key) => {
              message.push(key + ': ' + error.response.data[key])
            })
            self.launchToast(message.join('<br>'), 'fa-close')
          } else {
            self.launchToast(this.$t('auth.error_login'), 'fa-close')
          }
        })
    },
  },
}
</script>

<style lang="scss">
</style>
